// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"67d62cdf","419":"d1760812","496":"737da756","563":"3952217f","600":"d103264b","942":"0a3aa49b"}[chunkId] + ".chunk.js";
};